import React, {useContext} from 'react';
import {Redirect} from "react-router-dom";

import {MainContext} from "../contexts/MainContext";

export default function NonActivated(props)
{
    const {main} = useContext(MainContext);

    return (
    <>
        {
            (function ()
            {
                if (main.validated)
                {
                    if (main.expired || main.token === null)
                        return <Redirect to={'/login'}/>

                    if (main.activated)
                        return <Redirect to={'/'}/>

                    return props.children;
                }
            })()
        }
    </>
    );
}